import React from "react";
import { Container } from "reactstrap";
import { FiUserCheck } from "react-icons/fi";
import { Bell } from "assets";
import "./ahliWaris.scss";

/**
 * Halaman Ahli Waris — masih placeholder.
 *
 * Menu dan rutenya sudah disiapkan supaya navigasinya bisa dipakai lebih dulu,
 * sementara isinya menyusul. Saat fitur sebenarnya dikerjakan, ganti bagian
 * <div className="coming-soon"> dengan konten halaman; kerangka header di
 * atasnya sudah mengikuti halaman lain.
 */
const AhliWaris = () => {
  return (
    <Container fluid className="content-pencipta">
      <div className="header-content">
        <div className="pencipta-header">
          <h1>Ahli Waris</h1>
        </div>
        <div className="icon-wrapper">
          <Bell />
        </div>
      </div>

      <div className="coming-soon">
        {/* Ikon dan animasinya murni hiasan — statusnya sudah disampaikan
            lewat teks di bawah, jadi disembunyikan dari pembaca layar. */}
        <div className="coming-soon-icon" aria-hidden="true">
          <span className="coming-soon-pulse" />
          <FiUserCheck />
        </div>

        <div className="coming-soon-copy">
          <h2 className="coming-soon-title">Segera Hadir</h2>
          <p className="coming-soon-text">
            Halaman Ahli Waris sedang dalam pengembangan. Fitur untuk mengelola
            data ahli waris akan tersedia pada pembaruan berikutnya.
          </p>
        </div>

        <div
          className="coming-soon-progress"
          role="status"
          aria-label="Halaman sedang dalam pengembangan"
        >
          <span aria-hidden="true" />
        </div>
      </div>
    </Container>
  );
};

export default AhliWaris;
